module.exports = __webpack_public_path__ + "img/easy_rent_a_car3.a45f5a2a.jpg";